import React from "react";
import {Row} from "react-bootstrap";
import NawContactsDetailOffersTable from "./NawContactsDetailOffersTable";

function NawContactsDetailOffersTableHandler({detailOffers}) {
    //laat tabel zien met gegevens via props
    if (detailOffers.length > 0) return <NawContactsDetailOffersTable detailOffers={detailOffers}/>;
    else
        return (
            <Row className="justify-content-center align-self-center w-100 text-center">
                Er zijn geen offertes gevonden.
            </Row>
        );
}

export default NawContactsDetailOffersTableHandler;